<template>
  <VDropdown
    :auto-hide="true"
    :distance="24"
    :shown="popoverOpen"
    :placement="'auto'"
    :popper-class="'share-popover'"
    :triggers="[]"
    @hide="handlePopoverHide"
  >
    <circular-icon-button
      icon-name="share-item"
      :icon-size="15"
      @click="triggerShare"
    />
    <template #popper>
      <div class="heading">
        {{ title }}
      </div>
      <div class="subheading">
        {{ text }}
      </div>
      <share-box :url="url" />
    </template>
  </VDropdown>
</template>

<script>
import CircularIconButton from '@/components/ui/CircularIconButton';
import ShareBox from '@components/share/shareBox';

export default {
  components: {
    CircularIconButton,
    ShareBox,
  },
  props: {
    category: {
      type: Object,
    },
    context: {
      type: String,
      default: '',
    },
    flashcard: {
      type: Object,
    },
  },
  data() {
    return {
      popoverOpen: false,
    };
  },
  computed: {
    config() {
      return this.$store.getters['productVars/get']['flashcardShareMessage']?.parsedValue;
    },
    message() {
      return this.config?.message_text || this.text;
    },
    title() {
      return this.config?.title || 'Ask a Friend';
    },
    text() {
      return this.config?.text || 'Share this question with a BFF.';
    },
    url() {
      const cfg = this.config;
      const fid = this.flashcard?.id;
      if (!cfg?.url || fid == null || fid === '') {
        return '';
      }
      let u = `${cfg.url}?fid=${fid}`;
      if (cfg.sc) {
        u += `&sc=${cfg.sc}`;
      }
      return u;
    },
    analyticsParams() {
      const data = {
        'Asset ID': this.flashcard?.id,
        'Asset Title': this.flashcard?.question,
        'Asset Type': 'Question',
        'Category ID': this.category?.id,
        'Category Name': this.category?.name,
      };

      if (this.context === 'rationale') {
        data['Location'] = 'Question Explanation';
      } else if (this.context === 'question' || this.context === 'header') {
        data['Location'] = 'Question Header';
      } else {
        data['Location'] = 'Question Footer';
      }

      return data;
    },
  },
  methods: {
    triggerShare() {
      if (navigator.share) {
        this.$analytics.events.sharedAsset(this.analyticsParams);
        navigator.share({
          text: this.message,
          url: this.url,
        }).catch((error) => {
          if (error.name !== 'AbortError') {
            this.popoverOpen = true;
          }
        });
      } else {
        this.popoverOpen = true;
        this.$analytics.events.copiedShareLink(this.analyticsParams);
      }
    },
    handlePopoverHide() {
      this.popoverOpen = false;
    },
  },
};
</script>

<style lang="scss">
.share-popover.v-popper--theme-dropdown {
  max-width: rem-calc(400);

  .v-popper__inner {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
    color: black;
    padding: rem-calc(24);

    .heading {
      font-weight: 600;
      margin-bottom: rem-calc(8);
    }

    .subheading {
      color: #767676;
      font-size: rem-calc(14);
      letter-spacing: -0.5px;
      margin-bottom: rem-calc(20);
    }
  }

  .v-popper__arrow-container {
    display: none;
  }
}
</style>
